module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增藥物"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genericName),
      expression: "genericName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.genericName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.genericName = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CGMHNumber),
      expression: "CGMHNumber"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.CGMHNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CGMHNumber = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageCode2),
      expression: "packageCode2"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.packageCode2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packageCode2 = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packContent),
      expression: "packContent"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.packContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packContent = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restrainedClass),
      expression: "restrainedClass"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.restrainedClass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.restrainedClass = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseId),
      expression: "licenseId"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.licenseId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseId = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manufacturer),
      expression: "manufacturer"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.manufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manufacturer = $event.target.value
      }
    }
  })])]), _c('hr'), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": _vm.addDrug
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥碼*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("學名*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("料位號*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥盒條碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("產品名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("單包裝含量*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("管制等級*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("衛生署字號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("製造廠商")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e37fb90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CreateMedicineForm.vue
// module id = 1383
// module chunks = 1